import React, { useContext, useState, useEffect, useMemo } from "react";
import { SearchContext } from "./SearchContext";
import { useLocation, useNavigate } from "react-router-dom";
import { filterProviders } from "../utils/filterData";

const AdvSearchFilterList = () => {
  const { advSearchList, originalData } = useContext(SearchContext);
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const currentAdvSearch = searchParams.get("adv_search_term");
  const selectedAdvSearch = !currentAdvSearch || currentAdvSearch === "all" ? [] : currentAdvSearch.split(",");

  // Consider support filters
  const currentSupport = searchParams.get("support_term");
  const selectedSupports = !currentSupport || currentSupport === "all" ? [] : currentSupport.split(",");

  const [localAdvSearch, setLocalAdvSearch] = useState(selectedAdvSearch);

  useEffect(() => {
    const newParams = new URLSearchParams(location.search);
    if (localAdvSearch.length > 0) {
      newParams.set("adv_search_term", localAdvSearch.join(","));
    } else {
      newParams.delete("adv_search_term");
    }
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localAdvSearch]);

  // supportOnlyData: Apply support filters only, ignoring advanced search filters
  const supportOnlyData = useMemo(() => {
    return filterProviders(originalData, selectedSupports, []);
  }, [originalData, selectedSupports]);

  // Compute counts from supportOnlyData (no advanced terms considered)
  const advSearchCounts = {};
  for (const provider of supportOnlyData) {
    for (const term of provider.advanced_services) {
      if (!advSearchCounts[term.term_id]) {
        advSearchCounts[term.term_id] = 0;
      }
      advSearchCounts[term.term_id]++;
    }
  }

  const sortedAdvSearchList = useMemo(() => {
    return [...advSearchList].sort((a, b) => a.name.localeCompare(b.name));
  }, [advSearchList]);

  const isChecked = termId => localAdvSearch.includes(termId.toString());

  const handleCheckboxChange = termId => {
    setLocalAdvSearch(prevSelected => {
      if (prevSelected.includes(termId.toString())) {
        return prevSelected.filter(id => id !== termId.toString());
      } else {
        return [...prevSelected, termId.toString()];
      }
    });
  };

  const handleClearFilter = () => {
    setLocalAdvSearch([]);
  };

  console.log("advanced list", advSearchList);
  console.log("sorted advanced list", sortedAdvSearchList);

  return (
    <div className="px-2">
      {localAdvSearch.length > 0 && (
        <div className="py-1 mb-2">
          <button type="button" className="text-blue-600 underline hover:no-underline" onClick={handleClearFilter}>
            Clear Filter
          </button>
        </div>
      )}

      {sortedAdvSearchList.map(term => {
        const count = advSearchCounts[term.term_id] || 0;
        if (count === 0) {
          // Term doesn't appear under the current support filters at all
          return null;
        }

        // Show term with count from supportOnlyData, ignoring advanced selection for counts
        return (
          <div key={term.term_id} className="flex items-center py-1">
            <input type="checkbox" className="rounded border text-primaryBlue border-primaryBlue px-2 py-1 focus:ring-2 focus:ring-primaryBlue" id={`adv-${term.term_id}`} name={term.name} value={term.term_id} checked={isChecked(term.term_id)} onChange={() => handleCheckboxChange(term.term_id)} />
            <label htmlFor={`adv-${term.term_id}`} className="ml-2 my-0">
              {term.name} [{count}]
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default AdvSearchFilterList;
